// product add-on
document.addEventListener('DOMContentLoaded', () => {
  initializeAddonHandling();
  initProductPopup();
  
  $('.gift-box-cta[data-fancybox]').fancybox({
    afterShow: function (instance, current) {
      initSliders(); // 👉 Gọi Flickity sau khi popup đã hiển thị
    }
  });
});

const initializeAddonHandling = () => {
  const form = document.querySelector('form[action="/cart/add"]');
  if (!form) return;

  form.addEventListener('submit', async (event) => {
    const yesRadios = document.querySelectorAll('.gift-box-controller input[type="radio"][value="Yes"]:checked');
    const selectedCatalogItems = document.querySelectorAll('.catalog-grid-card__item[data-variant-id]:not([data-label="no-thanks"])');

    const hasAddons = yesRadios.length > 0 || selectedCatalogItems.length > 0;
    if (!hasAddons) return; // không có addon → submit bình thường

    event.preventDefault();

    try {
      const radioVariants = collectVariantIdsFromElements(yesRadios);
      const catalogVariants = collectVariantIdsFromElements(selectedCatalogItems);

      if (radioVariants.length > 0) {
        await submitAddons(radioVariants);
      }

      if (catalogVariants.length > 0) {
        await submitAddons(catalogVariants);
      }

      await submitMainProduct(form);
      window.location.href = '/cart';
    } catch (err) {
      console.error("❌ Lỗi khi submit:", err);
    }
  });
};

// ✅ Lấy variant ID từ các radio được chọn là "Yes"
const collectVariantIdsFromElements = (elements) => {
  const variantIds = [];

  elements.forEach(el => {
    const rawId = el.dataset.variantId;
    const variantId = parseInt(rawId);
    if (variantId && !variantIds.includes(variantId)) {
      variantIds.push(variantId);
    }
  });

  return variantIds;
};

// ✅ Gửi sản phẩm chính
const submitMainProduct = async (form) => {
  const formData = new FormData(form);
  const id = parseInt(formData.get("id"));
  const quantity = parseInt(formData.get("quantity")) || 1;

  const payload = { items: [{ id, quantity }] };

  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) throw new Error("Lỗi khi thêm sản phẩm chính");
};

// ✅ Gửi các sản phẩm add-on
const submitAddons = async (addonIds) => {
  const items = addonIds.map((id) => ({
    id,
    quantity: 1,
  }));

  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    body: JSON.stringify({ items }),
  });

  if (!response.ok) throw new Error("Lỗi khi thêm sản phẩm add-on");
};
// end - product add-on

const initProductPopup = (options = {}) => {
  const {
    selector = ".catalog-grid-card__item",
    view = "addon-catalog", // dùng dạng ?view=quickview
    modalId = ".catalog-product-popup"
  } = options;

  const modal = document.querySelector(modalId);
  if (!modal) return console.error("❌ Modal element not found");

  const modalBody = modal.querySelector("#custom-modal-body");
  const closeBtn = modal.querySelector("#custom-modal-close");

   let lastOpenedHandle = null;

  function openModal(content = "Loading...", callback) {
    modalBody.innerHTML = content;
    if (typeof callback === "function") callback();
    modal.classList.add("open");
  }

  function closeModal() {
    // const selectedEl = modal.querySelector(".product-addon-catalog__variant-item.selected");

    // if(!selectedEl || selectedEl.dataset.label == 'no-thanks'){
    //   if(!modal.nextElementSibling.classList.contains("open")){
    //     modal.nextElementSibling.classList.add("open");
    //   } else {
    //     modal.nextElementSibling.classList.remove("open");
    //   } 
    // }else{
    //   modal.classList.remove("open");
    // }
    destroyFlickityInModal();
    modal.classList.remove("open");
  }

  closeBtn?.addEventListener("click", closeModal);
  window.addEventListener("click", (e) => {
    if (e.target === modal) closeModal();
  });

  document.querySelector('.catalog-product-addon .dialog-header').addEventListener("click", () => {
    closeModal()
  });

  document.querySelector('.catalog-product-addon .btn-confirm-yes').addEventListener("click", () => {
    closeModal();
    modal.classList.remove("open");
  });

  document.querySelector('.catalog-product-addon .btn-confirm-no').addEventListener("click", () => {
    closeModal();
  });

  document.querySelector('[data-label="no-thanks"]').addEventListener("click", (e) => {
    const attrName = "data-variant-id"
    e.target.setAttribute(attrName, 'no-thanks')
    const parent = e.target.closest('.catalog-product-addon');
    const gridCards = parent.querySelectorAll(`.catalog-grid-card__item:not([data-label="no-thanks"])`);
    const selected = parent.querySelectorAll('.catalog-product-popup .product-addon-catalog__variant-item.selected');
    
    gridCards.forEach((el) => {
      if(el.hasAttribute(attrName) && el.getAttribute(attrName).trim() !== ''){
        el.removeAttribute(attrName);
      }
    });

    selected.forEach((el) => {
      if(el.classList.contains('selected')){
        el.classList.remove("selected");
      }
    });
  });

  document.querySelectorAll(selector).forEach((el) => {
    el.addEventListener("click", async () => {
      const handle = el.dataset.productHandle;
      if (!handle) return;

      if (lastOpenedHandle === handle) {
        // Nếu đã mở → không fetch lại, chỉ mở lại modal
        openModal(modalBody.innerHTML , () => {
          initSliders({wrappers: ".product-addon-catalog__media", slideItem: ".product-addon-catalog__sliders"});
          initVariantSelector();
        });
        return;
      }

      try {
        const res = await fetch(`/products/${handle}?view=${view}`);
        const html = await res.text();

        lastOpenedHandle = handle;

        openModal(html, () => {
          initSliders({wrappers: ".product-addon-catalog__media", slideItem: ".product-addon-catalog__sliders"});
          initVariantSelector();
        }); // toàn bộ nội dung của template view
      } catch (err) {
        console.error("❌ Error loading product view:", err);
        openModal("Unable to load product data. Please try again later.");
      }
    });
  });
}

function initVariantSelector({
  containerSelector = ".product-addon-catalog__variant",
  itemSelector = ".product-addon-catalog__variant-item",
} = {}) {
  const container = document.querySelector(containerSelector);
  if (!container) return;

  const productHandle = container.dataset.productHandle;
  if (!productHandle) {
    console.warn("❗ Missing data-product-handle on variant container");
    return;
  }

  const parent = container.closest(".product-addon-catalog");
  const items = container.querySelectorAll(itemSelector);
  const catalogItems = document.querySelectorAll('.catalog-grid-card__item');
  const priceEl = parent.querySelector('.product-addon-catalog__price');
  const moneyFormat = document.body.dataset.moneyFormat;

  const sliderEl = parent.querySelector(".product-addon-catalog__sliders");
  const flickity = sliderEl?.flickityInstance || Flickity.data(sliderEl);

  items.forEach(item => {
    item.addEventListener("click", () => {
      // Highlight selected item
      items.forEach(i => i.classList.remove("selected"));
      item.classList.add("selected");

      const price = item.dataset.price;
      const comparePrice = item.dataset.comparePrice;

      if(item.dataset.label == 'no-thanks'){
        priceEl.style.display = 'none';
      } else {
        priceEl.style.display = '';
      }
      priceEl.querySelector('.price').textContent = window.Shopify.formatMoney(price, moneyFormat);
      if(comparePrice){
        priceEl.querySelector('.compare-at-price').textContent = window.Shopify.formatMoney(comparePrice, moneyFormat);
      }

      const variantId = item.dataset.variantId || "";

      // Gán variant ID về card tương ứng
      for (const catalog of catalogItems) {
        if (catalog.dataset.productHandle === productHandle) {
          catalog.setAttribute('data-variant-id', variantId);
        } else {
          catalog.removeAttribute('data-variant-id');
        }
      }

      // 🔁 Đồng bộ media (Flickity)
      const variantSrc = item.querySelector(".image-element__wrap img")?.dataset.src?.trim();
      if (flickity && variantSrc) {
        const slides = sliderEl.querySelectorAll(".gallery-cell");
        for (let i = 0; i < slides.length; i++) {
          const slideSrc = slides[i].querySelector(".image-element__wrap img")?.dataset.src?.trim();
          if (slideSrc === variantSrc) {
            flickity.select(i);
            break;
          }
        }
      }
    });
  });
}

const initSliders = (options = {}) => {
  const {
    wrappers = ".product-addon-media",
    slideItem = ".product-addon-media-sliders"
  } = options;

  const wrapperEls = document.querySelectorAll(wrappers);
  if (!wrapperEls || wrapperEls.length === 0) return;
  wrapperEls.forEach(wrapper => {
    const slider = wrapper.querySelector(slideItem);
    if (!slider) return;

    const slides = slider.querySelectorAll('.gallery-cell');
    const arrowShow = slides.length > 1;

    const flickityInstance = safeReinitFlickity(slider, {
      adaptiveHeight: false,
      wrapAround: true,
      cellAlign: 'left',
      imagesLoaded: true,
      prevNextButtons: false,
      draggable: arrowShow,
      autoPlay: false,
      pageDots: false
    });

    slider.flickityInstance = flickityInstance;
    slider.dataset.flickityInitialized = 'true';

    const nextBtn = wrapper.querySelector('.slider-next');
    const prevBtn = wrapper.querySelector('.slider-prev');

    if (nextBtn) nextBtn.addEventListener('click', () => flickityInstance.next());
    if (prevBtn) prevBtn.addEventListener('click', () => flickityInstance.previous());
  });
}

const destroyFlickityInModal = () => {
  const sliders = document?.querySelectorAll(".product-addon-catalog__sliders");

  sliders?.forEach(slider => {
    const instance = Flickity.data(slider);
    if (instance) {
      instance.destroy();
      slider.dataset.flickityInitialized = '';
    }
  });
}

const safeReinitFlickity = (slider, config = {}) => {
  if (!slider) return null;

  // Nếu đã có instance → destroy để reset
  const existingInstance = Flickity.data(slider);
  if (existingInstance) {
    existingInstance.destroy();
    slider.dataset.flickityInitialized = '';
  }

  const flickityInstance = new Flickity(slider, config);
  return flickityInstance;
}